import { render, staticRenderFns } from "./transaction-files.vue?vue&type=template&id=74a277aa&scoped=true&"
import script from "./transaction-files.vue?vue&type=script&lang=js&"
export * from "./transaction-files.vue?vue&type=script&lang=js&"
import style0 from "./transaction-files.vue?vue&type=style&index=0&id=74a277aa&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74a277aa",
  null
  
)

export default component.exports